import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api, { getPublicSettings } from "@/lib/api";

export function WhatsAppFab() {
  const [wa, setWa] = useState("919823567811");
  useEffect(() => { getPublicSettings().then((d) => { if (d.support_whatsapp) setWa(d.support_whatsapp); }).catch(() => {}); }, []);
  return (
    <a
      href={`https://wa.me/${wa}?text=Hi%20Credit%20Kendra%2C%20I%20need%20help`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      title="Chat with us on WhatsApp"
      className="fixed bottom-5 right-5 z-[90] w-13 h-13 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] rounded-full shadow-xl shadow-teal-900/20 transition-transform hover:scale-110"
      style={{ width: 52, height: 52 }}
    >
      <MessageCircle className="w-6 h-6 fill-white text-[#25D366]" />
    </a>
  );
}
